export const Full = '100%';
